import { useEffect, useState } from 'react';
import { formatRelative } from '../../utils/format';

export interface FreshnessProps {
  /** Epoch ms of last update. */
  updatedAt: number;
}

/**
 * Relative-time pill that auto-refreshes every 30 seconds.
 */
export function Freshness({ updatedAt }: FreshnessProps) {
  const [, force] = useState(0);
  useEffect(() => {
    const id = setInterval(() => force((n) => n + 1), 30_000);
    return () => clearInterval(id);
  }, []);
  return (
    <span className="honesty-freshness" title={new Date(updatedAt).toISOString()}>
      עודכן {formatRelative(updatedAt)}
    </span>
  );
}
